module.exports = __webpack_public_path__ + "categories/icon-feature-price-791f7ad65cb54fa2634665c8dfc6c093.svg";